import { render, staticRenderFns } from "./AppIndexCard.vue?vue&type=template&id=3c5a6174&scoped=true&"
import script from "./AppIndexCard.vue?vue&type=script&lang=ts&"
export * from "./AppIndexCard.vue?vue&type=script&lang=ts&"
import style0 from "./AppIndexCard.vue?vue&type=style&index=0&id=3c5a6174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a6174",
  null
  
)

export default component.exports